import { render, staticRenderFns } from "./zhuan3.vue?vue&type=template&id=5452f2f0&scoped=true&"
import script from "./zhuan3.vue?vue&type=script&lang=js&"
export * from "./zhuan3.vue?vue&type=script&lang=js&"
import style0 from "./zhuan3.vue?vue&type=style&index=0&id=5452f2f0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5452f2f0",
  null
  
)

export default component.exports